import { Activity, Plus, RotateCcw, Settings, Square, Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface OperatorConsoleToolbarProps {
  accessLabel: string;
  selectedSessionId?: string;
  canInspectUsers: boolean;
  onInspectUsers: () => void;
  onClearSessionRoute: () => void;
}

export function OperatorConsoleToolbar({
  accessLabel,
  selectedSessionId,
  canInspectUsers,
  onInspectUsers,
  onClearSessionRoute,
}: OperatorConsoleToolbarProps) {
  return (
    <Card>
      <CardHeader className="gap-3 border-b border-border">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="grid gap-1">
            <div className="flex flex-wrap items-center gap-2">
              <CardTitle>Operator Console</CardTitle>
              <Badge variant="draft">Scaffolding</Badge>
              <Badge variant="outline">{accessLabel}</Badge>
            </div>
            <CardDescription>
              Dedicated maintenance surface for TUI parity work. The normal conversation route stays non-technical.
            </CardDescription>
          </div>
          {selectedSessionId ? (
            <div className="text-xs" style={{ color: "var(--muted-foreground)" }}>
              Session route: {selectedSessionId}
            </div>
          ) : null}
        </div>
      </CardHeader>
      <CardContent className="flex flex-wrap gap-2 pt-4">
        <Button variant="outline" size="sm" disabled>
          <Plus className="size-4" />
          New Session
        </Button>
        <Button variant="outline" size="sm" disabled>
          <RotateCcw className="size-4" />
          Reset Session
        </Button>
        <Button variant="outline" size="sm" disabled>
          <Square className="size-4" />
          Abort Run
        </Button>
        <Button variant="outline" size="sm" disabled>
          <Activity className="size-4" />
          Gateway Status
        </Button>
        <Button variant="outline" size="sm" disabled>
          <Settings className="size-4" />
          Settings
        </Button>
        {canInspectUsers ? (
          <Button variant="outline" size="sm" onClick={onInspectUsers}>
            <Users className="size-4" />
            Inspect User Sessions
          </Button>
        ) : null}
        {selectedSessionId ? (
          <Button variant="ghost" size="sm" onClick={onClearSessionRoute}>
            Clear Session Route
          </Button>
        ) : null}
      </CardContent>
    </Card>
  );
}
